import React, { useState } from 'react';
import CaseList from '../CaseList';
import AssignedCasesFilter from './AssignedCasesFilter';
import styles from './../CaseList.module.scss';
import useCases from '../../../Hooks/useCases';
import { useLazyCasesAssignedQuery } from '../../../../../graphql/graphql';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import useSocket from '../../../../Base/Hooks/useSocket';
import { Socket } from '../../../../Base/Enums/Socket.enum';
import { useAppContext } from '../../../../../Services/AppContext';

const AssignedCasesList: React.FC = () => {
	const [isFilterReady, setIsFilterReady] = useState(false);
	const { workplaceId } = useAppContext();

	const [getWorkplaceCasesQuery, { data, isLoading }] =
		useLazyCasesAssignedQuery();

	const { getWorkplaceCases, getNextPage, page, setPage } = useCases(
		getWorkplaceCasesQuery,
	);

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getWorkplaceCases,
		{
			data: data?.casesAssigned?.data,
			totalPages: data?.casesAssigned?.meta?.totalPages,
			page: data?.casesAssigned?.meta?.page,
		},
		page,
		setPage,
		{
			onlyVisible: true,
			workplaceId,
		},
		isFilterReady,
	);

	useSocket(Socket.CASE_TAKEN, loadData);

	return (
		<div className={styles.wrapper}>
			<AssignedCasesFilter
				onFilter={setFilter}
				onReady={() => setIsFilterReady(true)}
			/>

			<CaseList
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={() => loadData(true)}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
			/>
		</div>
	);
};

export default AssignedCasesList;
